import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const ReimbursementIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      fill="none"
      {...props}
    >
      <rect width={36} height={36} fill={theme.palette.grey[100]} rx={18} />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="M18 20.887V13.38"
      />
      <circle
        cx={18}
        cy={18}
        r={8.374}
        stroke={theme.palette.common.black}
        strokeWidth={1.25}
      />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="m21.465 18-3.295 3.295a.24.24 0 0 1-.34 0L14.535 18"
      />
    </svg>
  );
};
